import { HIGH_SAMPLING_RATE_SCHEMA } from '@/shared/config';
import { zeroPad } from '@/shared/lib';

/**
 * Reports whether a device schema identifies a high sampling rate device. Zero-pads the schema to eight characters and compares it against the HIGH_SAMPLING_RATE_SCHEMA constant.
 *
 * @param schema - Device schema value to classify.
 * @returns True when the padded schema matches the high sampling rate schema.
 */
const checkUsingHighSamplingRateDevice = (schema: any) =>
  zeroPad(schema, 8) === HIGH_SAMPLING_RATE_SCHEMA;

export { checkUsingHighSamplingRateDevice };
